import { Container, Grid } from '@mui/material'
import React from 'react'
import { P, SectionHeading, SectionSmallHeading, SectionWrapper } from '../../../Styles/style'
import MyTable from './Components/Table'

const S2_Tokenomics = () => {
    return (
        <div>
            <SectionWrapper p="4rem 0">
                <Container maxwidth="xl">
                    <SectionHeading align="center" p="30px 0 10px" data-aos="zoom-in"
                        data-aos-easing="ease-in"
                        data-aos-delay="300"
                        data-aos-offset="0"
                        data-aos-duration="1000">Tokenomics</SectionHeading>
                    <P align="center" p="0 0 50PX" m="0" data-aos="fade-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="300"
                        data-aos-offset="0"
                        data-aos-duration="1000">Token Distribution Sheet</P>
                    <Grid container>
                        <Grid xs={12} sm={2.5} >
                            <P p="0" m="0" data-aos="zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="400"
                                data-aos-offset="0"
                                data-aos-duration="1000">Token Name</P>
                            <SectionSmallHeading align="left" fs="30px" data-aos="fade-up"
                                data-aos-easing="ease-in"
                                data-aos-delay="400"
                                data-aos-offset="0"
                                data-aos-duration="1000">$Incognito</SectionSmallHeading>
                        </Grid>
                        <Grid xs={12} sm={2.5}>
                            <P p="0" m="0" data-aos="zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="600"
                                data-aos-offset="0"
                                data-aos-duration="1000">Total Supply</P>
                            <SectionSmallHeading align="left" fs="30px" data-aos="fade-up"
                                data-aos-easing="ease-in"
                                data-aos-delay="600"
                                data-aos-offset="0"
                                data-aos-duration="1000">TBA</SectionSmallHeading>
                        </Grid>
                        <Grid xs={12} sm={2.5}>
                            <P p="0" m="0" data-aos="zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="800"
                                data-aos-offset="0"
                                data-aos-duration="1000">Token Generation Event</P>
                            <SectionSmallHeading align="left" fs="30px" data-aos="fade-up"
                                data-aos-easing="ease-in"
                                data-aos-delay="800"
                                data-aos-offset="0"
                                data-aos-duration="1000">TBA</SectionSmallHeading>
                        </Grid>
                        <Grid xs={12} sm={3} />
                    </Grid>
                    <br />
                    <br />
                    <br />
                    <MyTable />
                </Container>

            </SectionWrapper>
        </div>
    )
}

export default S2_Tokenomics